export const Routes = {
  DEFAULT: '/',
  HOME: '/home',
  LOGIN: '/login',
  LOGOUT: '/logout',
  MANAGEMENT: '/management',
  SIGNUP: '/sign-up',
  ERROR: '/error',
  PASSWORD_RECOVERY: '/password-recovery',
  DISPUTES: '/disputes',
  DISPUTES_MULTIPLE_EDIT: '/disputes/multiple',
  DISPUTES_EDIT: '/disputes',
  //ENROLLMENT: '/enrollment',
  EDITDISPUTES:'/editdisputes',
  LANGUAGES: '/Languages',
  CONTACT_DATA:'/contact-data',
  ENROLLMENT:'/contact-data'
}
